import { bool, number, object, string } from "yup";
import ProductType from "../../common/interfaces/enums/ProductType";
import TraumaType from "../../common/interfaces/enums/TraumaType";
import { IQuoteClient } from "../interfaces/form/IQuoteClient";
import { ITraumaQuoteClient } from "../interfaces/form/trauma/ITraumaQuoteClient";
import { isSelected } from "./ValidationHelpers";

const client = object<ITraumaQuoteClient>({
    isSelected: bool().notRequired().default(false),
    coverAmount: isSelected(
        number(),
        number()
            .positive("Cover amount must be greater than 0")
            .required("Please provide a trauma cover amount")
    ),
    traumaType: isSelected(
        string<TraumaType>(),
        string<TraumaType>().required("Please select a trauma type")
    )
})
    .test(
        "accelerated-trauma-has-life",
        "You must have an life cover to have accelerated trauma",
        function (trauma) {
            if (trauma.traumaType !== TraumaType.Accelerated) return true;

            return !!this.parent[ProductType.Life];
        }
    )
    .test(
        "accelerated-trauma-life-cover-amount",
        "Your accelerated cover amount cannot be more than your life cover amount",
        function (trauma): boolean {
            const parent: IQuoteClient = this.parent;

            if (trauma.traumaType !== TraumaType.Accelerated) return true;

            return trauma.coverAmount <= parent[ProductType.Life]?.coverAmount;
        }
    );

export default { client };
